'use strict';

var implementation = require('./implementation');

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/string.prototype.trim/polyfill.js
// module id = 453
// module chunks = 0